/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    home: {
      init: function() {
        // JavaScript to be fired on the home page
        
      },
      finalize: function() {
      }
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function(
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");

      $(".slider-proyectos").owlCarousel({
        items: 4,
        loop: true,
        nav: true,
        responsiveClass: true,
        responsive: {
          320: {
            items: 1,
            nav: true
          },
          576: {
            items: 1,
            nav: true
          },
          768: {
            items: 3,
            nav: true
          },
          1000: {
            items: 4,
            nav: true,
            loop: false
          }
        },
        autoplay: false,
        autoplayTimeout: 3000,
        dots: false
      });

      $('.swipebox').swipebox({
        useCSS : true, // false will force the use of jQuery for animations
        useSVG : true, // false to force the use of png for buttons
        initialIndexOnArray : 0, // which image index to init when a array is passed
        hideCloseButtonOnMobile : false, // true will hide the close button on mobile devices
        removeBarsOnMobile : true, // false will show top bar on mobile devices
        hideBarsDelay : false, // delay before hiding bars on desktop
        videoMaxWidth : 1140, // videos max width
        loopAtEnd: true // true will return to the first image after the last image is reached
      });

      $(".slider-videos").owlCarousel({
        items: 1,
        loop: true,
        nav: true,
        center: false,
        margin: 30,
        autoplay: false,
        autoplayTimeout: 3000,
        dots: false
      });
      $(".slider-I-servicios").owlCarousel({
        items: 8,
        loop: false,
        nav: false,
        center: false,
        margin: 15,
        autoplay: false,
        autoplayTimeout: 3000,
        dots:false,
        responsive: {
          320: {
            items: 2,
            touchDrag:true,
            mouseDrag:true,
            dots:true,
            dotsEach:2,
          },
          576: {
            items: 3,
            touchDrag:true,
            mouseDrag:true,
            dots:true,
            dotsEach:2,
          },
          768: {
            items: 6,
            dots:true,
            dotsEach:1,
          },
          1200: {
            items: 6,
            dots:true,
            dotsEach:1,
            loop: false,
          },
          1201:{
            items: 8,
          }
        },
      });

      
      
    }
  };
  var txt = document.querySelectorAll(".descripcion-proyecto > h4.proyectos");
  setTimeout(function() { equalHeight(txt) }, 1200);
  var ps = document.querySelector(
    "#I-servicios  .servicio-c"
  );
  if(ps){
    var ids = ps.getAttribute("id");
  servicio(ids);
  }
  var ps = document.querySelector(
    "#servicios .row .col-xl-2 .servicio-c"
  );
  if(ps){
    var ids = ps.getAttribute("id");
  servicio(ids);
  }
  
  // $(document).on('resize', foo());
  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point

function servicio(id) {
  var todos = document.getElementsByClassName("servicio");
  var blanca = document.getElementsByClassName("blanca");
  var verde = document.getElementsByClassName("verde");
  var servicio = document.getElementById("d-servicio" + id);
  var servicio_i_v = document.getElementById("verde" + id);
  var servicio_i_b = document.getElementById("blanca" + id);
  var servicio_t = document.getElementById("p" + id);
  var textos = document.querySelectorAll("#servicios .servicio-c p");
  var textos_i = document.querySelectorAll("#I-servicios .servicio-c p");
  var interna = location.pathname.search("/servicios");
  for (var a = 0; textos.length > a; a++) {
    textos[a].style.color = "#f4f4f4";
  }

  
  for (var a = 0; textos_i.length > a; a++) {
    textos_i[a].style.fontWeight="unset";
  }

  function loop(b, c) {
    for (var a = 0; b.length > a; a++) {
      b[a].style.display = c;
    }
  }
  loop(todos, "none");
  loop(blanca, "block");
  loop(verde, "none");
 
  servicio_t.style.color = "#09fcce";
  if(interna!== -1){
   
    servicio_t.style.color = "#005b89";
  }
  servicio_i_b.style.display = "none";
  servicio_i_v.style.display = "block";
  servicio.style.display = "block";
}

function equalHeight(elements) {
  var maxHeight = 0;
  elements.forEach(function(element) {
    var currentHeight = element.offsetHeight;
    if(currentHeight > maxHeight) {
      maxHeight = currentHeight;
    }
  });
  asigHeight(elements, maxHeight);
}
function asigHeight(elements, value) {
  elements.forEach(function(element) {
    element.style.height = 'auto';
    element.style.height = value+'px';
  });
}

window.addEventListener('resize', function() {
  var txt = document.querySelectorAll(".descripcion-proyecto > h4.proyectos");
  equalHeight(txt);
  
});

function ubicacion(id) {
  var todos = document.getElementsByClassName("mapa");
  var info_h = document.getElementsByClassName("inf-contacto");
  for (var a = 0; todos.length > a; a++) {
    todos[a].style.opacity = "0";
  }
  for (var a = 0; info_h.length > a; a++) {
    info_h[a].style.display = "none";
  }
  var servicio = document.getElementById("mapa" + id);
  var info = document.getElementById(id).firstChild.nextSibling;
  servicio.style.opacity = "1";
  info.style.display = "block";
}

function plus(a){
  var card=document.getElementsByClassName("collapsed");
  for(var x =0; card.length>x; x++){
    card[x].classList.remove("active")
  }
  a.classList.toggle("active");

}





